import { toast } from 'react-toastify';

import { SpeedyCity } from '@models/speedy';
import { useMutation } from '@tanstack/react-query';

const { REACT_APP_TENISKI_API_BASE_URL } = process.env;

export const useSpeedyOfficesByCity = () => {
  const findOfficesByCity = async (city: SpeedyCity) => {
    const url = `${REACT_APP_TENISKI_API_BASE_URL}/speedy/findOfficesByCity`;

    const headers: Record<string, string> = {
      cityname: city.nameEn.toLowerCase()
    };
    if (city.id) {
      headers.siteid = String(city.id);
    }

    try {
      const response = await fetch(url, { headers });
      const data = await response.json();

      return data;
    } catch (e: unknown) {
      toast.error(`💥 ${(e as Error).message}`);
    }
  };

  return useMutation({
    mutationFn: (city: SpeedyCity) => findOfficesByCity(city)
  });
};
